import { render, staticRenderFns } from "./PhotoLayout.vue?vue&type=template&id=5cbc8d87"
import script from "./PhotoLayout.vue?vue&type=script&lang=js"
export * from "./PhotoLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports